module.exports = __webpack_public_path__ + "img/enfp.78b022d2.png";